// extracted by mini-css-extract-plugin
export default {"root":"AutocompletePanel_root__1US-k","suggestion":"AutocompletePanel_suggestion__8wfxd"};